"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ConnectGmailInbox = _interopRequireDefault(require("./ConnectGmailInbox"));

var _default = _ConnectGmailInbox.default;
exports.default = _default;
module.exports = exports.default;